import { createReducer } from 'typesafe-actions';

import { setActivityExportEntitlementNFT } from './actions';
import { ActivityExportEntitlementNFTType } from '@block-explorer/entities';

export type StateKey = 'entitlementNFTs';
export type StateValue = ActivityExportEntitlementNFTType[] | null;

export type State = Record<StateKey, StateValue>;

const initialState: State = {
  entitlementNFTs: null,
};

export default createReducer(initialState).handleAction(
  setActivityExportEntitlementNFT,
  (state, { payload }): State => ({
    ...state,
    entitlementNFTs: payload,
  })
);
